module.exports = __webpack_public_path__ + "favicon/favicon-16x16.png";